module.exports = __webpack_public_path__ + "img/superwebShopLogo.caf0204.svg";